import React from 'react';
import { StyleSheet } from 'react-native';
import { Authenticator } from 'be-components';
import { Modal } from "react-native";
import { View } from '../../../src/Components/Themed';
import type { AuthenticatedProps } from '../../../src/Authenticator/api/types';
import PortalModal from './PortalModal';

type AuthenticatorHolderProps = {
    company_id?:string
    mode: 'mobile'|'desktop',
    referral_code?:string,
    insets: { top:number, left:number, bottom:number, right:number },
    auth_strategy_id?:string,
    opt_in_url?:string,
    visible: boolean,
    onAuthenticated :(auth_stat:AuthenticatedProps) => void,
    onClose:() => void
}

const AuthenticatorHolder = ({ auth_strategy_id, company_id, insets, visible, mode, opt_in_url, referral_code, onAuthenticated, onClose}:AuthenticatorHolderProps) => {
    return (
        <Modal
            visible={visible}
            style={styles.modalContainer}
            animationType={mode=='desktop' ? 'fade' : 'slide'}
            transparent
        >
            <View type='blur' style={mode=='desktop'?styles.desktopContainer:{ ...styles.viewContainer, marginTop:insets.top, marginBottom:insets.bottom}}>
                <View float style={{ borderRadius:22, width:mode=='desktop'?500:undefined }}>
                    <Authenticator
                        theme="full"
                        visible={true}
                        show_referral
                        opt_in_url={opt_in_url}
                        company_id={company_id ?? '1'}
                        referral_code={referral_code ?? 'kickoff'}
                        onAuthenticated={(auth_response) => onAuthenticated(auth_response)}
                        auth_strategy_id={auth_strategy_id ?? '3'}
                        source="app"
                        onClose={() => onClose()}
                    />
                    </View>
                </View>
        </Modal>
    )
} 


const styles = StyleSheet.create({
    modalContainer: { flex:1 },
    viewContainer: { flex:1, justifyContent:'flex-end'},
    desktopContainer: { flex:1, justifyContent:'center', alignItems:'center' },
})


export default AuthenticatorHolder